// extracted by mini-css-extract-plugin
export var heading = "ShortDescription-module--heading--N5wI3";
export var reverse = "ShortDescription-module--reverse--+6mjv";
export var root = "ShortDescription-module--root--gI76G";
export var text = "ShortDescription-module--text--UXIOs";